import {
  calculateUploadProgress,
  endpointsList,
  getTotalFormDataSize,
} from '@/helpers';
import axios, { AxiosProgressEvent } from 'axios';
import { computed, ref } from 'vue';

export function useWorkspaceDocumentUpdate() {
  const totalFileSize = ref(0);
  const remainingFileSize = ref(0);

  const uploadProgress = computed(() =>
    calculateUploadProgress(totalFileSize.value, remainingFileSize.value),
  );

  async function updateWorkspaceDocumentFile(params: {
    workspaceId: string;
    documentId: string;
    mainFile: File;
    renditionFile?: File;
  }): Promise<void> {
    const { workspaceId, documentId, mainFile, renditionFile } = params;

    const formData = new FormData();
    formData.append('mainFile', mainFile);

    if (renditionFile) {
      formData.append('renditionFile', renditionFile);
    }

    await setTotalFileSize(formData);

    await axios.patch(
      endpointsList.workspaceUploads.updateWorkspaceDocumentFile(
        workspaceId,
        documentId,
      ),
      formData,
      {
        onUploadProgress: (event: AxiosProgressEvent) => {
          remainingFileSize.value = remainingFileSize.value - event.bytes;
        },
      },
    );
  }

  async function setTotalFileSize(formData: FormData): Promise<void> {
    const totalSize = await getTotalFormDataSize([formData]);
    totalFileSize.value = totalSize;
    remainingFileSize.value = totalSize;
  }

  return { updateWorkspaceDocumentFile, uploadProgress };
}
